if (!window.embedPlayersInitialized) {
    window.embedPlayersInitialized = true;

    var embedPlayers = Plyr.setup(".player-plyr", {
        controls: ["play", "progress", "current-time", "volume", "fullscreen"],
    });

    if (!isTouchDevice()) {
        const playCursor = document.createElement("div");
        playCursor.classList.add("play-cursor");
        playCursor.innerHTML = "PLAY";
        document.body.append(playCursor);

        embedPlayers.forEach((player) => {
            player.on("ready", (event) => {
                const instance = event.detail.plyr;
                const section =
                    instance.elements.container.closest(".video-section");

                section.addEventListener("mouseenter", function () {
                    if (!section.classList.contains("initialized")) {
                        playCursor.classList.add("show");
                    }
                });

                section.addEventListener("mouseleave", function () {
                    playCursor.classList.remove("show");
                });
            });

            player.on("playing", (event) => {
                const instance = event.detail.plyr;
                const section =
                    instance.elements.container.closest(".video-section");

                section.classList.add("initialized");
                playCursor.classList.remove("show");
            });
        });

        gsap.set(".play-cursor", { xPercent: -50, yPercent: -50 });

        var ball = document.querySelector(".play-cursor");
        var pos = { x: window.innerWidth / 2, y: window.innerHeight / 2 };
        var mouse = { x: pos.x, y: pos.y };
        var speed = 0.1;

        var xSet = gsap.quickSetter(ball, "x", "px");
        var ySet = gsap.quickSetter(ball, "y", "px");

        window.addEventListener("mousemove", (e) => {
            mouse.x = e.x;
            mouse.y = e.y;
        });

        gsap.ticker.add(() => {
            pos.x += (mouse.x - pos.x) * speed;
            pos.y += (mouse.y - pos.y) * speed;
            xSet(pos.x);
            ySet(pos.y);
        });
    } else {
        document.querySelectorAll(".video-section").forEach((section) => {
            let playCursor = document.createElement("div");
            playCursor.classList.add("play-cursor");
            playCursor.innerHTML = "PLAY";
            section.append(playCursor);
        });

        embedPlayers.forEach((player) => {
            player.on("click", (event) => {
                if (player.touch) {
                    const section =
                        player.elements.container.closest(".video-section");

                    player.togglePlay();
                    section.querySelector(".play-cursor").remove();
                }
            });
        });
    }
}
